'use client';
import React from 'react';
import PropTypes from 'prop-types';
import { HeaderLogo } from '../HeaderLogo';
import {
  StyledNavigationBar,
  OllieLogo,
  CenterAligned,
  LeftAligned,
  RightAligned,
  SkipToContent,
} from './styles.js';

export const NavigationBar = ({
  logoImg,
  logoUrl = '/',
  logoSrText = 'Ollie home',
  leftSegment,
  centerSegment,
  rightSegment,
  bgColor = 'background.dark',
  fontColor = 'text.lighter',
  showLogo = true,
  verticalPadding = 6,
  horizontalPadding = 6,
  fullBleedNav = false,
}) => {
  const hasCenterLinks = !(centerSegment === undefined);

  return (
    <StyledNavigationBar
      $bgColor={bgColor}
      $fontColor={fontColor}
      role="navigation"
      showLogo={showLogo}
      $verticalPadding={verticalPadding}
      $horizontalPadding={horizontalPadding}
      $fullBleedNav={fullBleedNav}
    >
      <SkipToContent href="#main">Skip to Content</SkipToContent>
      <LeftAligned>{leftSegment}</LeftAligned>
      {showLogo && (
        <OllieLogo $hasCenterLinks={hasCenterLinks}>
          <HeaderLogo
            logoImg={logoImg}
            logoSrText={logoSrText}
            logoUrl={logoUrl}
          />
        </OllieLogo>
      )}
      <CenterAligned $hasCenterLinks={hasCenterLinks}>
        {centerSegment}
      </CenterAligned>
      <RightAligned>{rightSegment}</RightAligned>
    </StyledNavigationBar>
  );
};

NavigationBar.propTypes = {
  bgColor: PropTypes.string,
  fontColor: PropTypes.string,
  logoImg: PropTypes.object,
  logoUrl: PropTypes.string,
  logoSrText: PropTypes.string,
  leftSegment: PropTypes.node,
  centerSegment: PropTypes.node,
  rightSegment: PropTypes.node,
  showLogo: PropTypes.bool,
  verticalPadding: PropTypes.number,
  fullBleedNav: PropTypes.bool,
};
